/* Westbury theme behaviour: announcement rotation, drawers, bag, variant picker,
   swatch image swap, shop-the-look hotspots, collection sort and filters. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.hidden = false;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('show');
      toastEl.hidden = true;
    }, 2600);
  }

  /* ---------- Drawers ---------- */
  var scrim = $('[data-scrim]');
  function closeDrawers() {
    $$('.drawer.open').forEach(function (d) { d.classList.remove('open'); });
    if (scrim) { scrim.classList.remove('open'); scrim.hidden = true; }
  }
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    closeDrawers();
    el.classList.add('open');
    if (scrim) { scrim.hidden = false; scrim.classList.add('open'); }
  }
  if (scrim) scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Header on scroll ---------- */
  var header = $('[data-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('clear', window.scrollY < 12 && document.body.classList.contains('template-index'));
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Announcement rotation ---------- */
  var items = $$('[data-announce] .announce-item');
  if (items.length > 1) {
    var current = 0;
    setInterval(function () {
      var bar = $('[data-announce]');
      bar.classList.add('fade');
      setTimeout(function () {
        items[current].hidden = true;
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].hidden = false;
        items[current].classList.add('is-active');
        bar.classList.remove('fade');
      }, 300);
    }, 4000);
  }

  /* ---------- Cart: sections rendering API ---------- */
  function refreshCart() {
    return fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var wrap = document.getElementById('shopify-section-cart-drawer');
        if (wrap && json['cart-drawer']) wrap.outerHTML = json['cart-drawer'];
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  function addToCart(id, quantity, properties) {
    var body = { id: id, quantity: quantity || 1 };
    if (properties) body.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to bag'); });
      return refreshCart();
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(); });
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open],[data-drawer-close],[data-cart-add],[data-cart-change],[data-acc],[data-swatch],[data-hot],[data-dlg]');
    if (!t) return;

    if (t.hasAttribute('data-drawer-open')) { e.preventDefault(); openDrawer(t.getAttribute('data-drawer-open')); return; }
    if (t.hasAttribute('data-drawer-close')) { closeDrawers(); return; }

    if (t.hasAttribute('data-cart-add')) {
      e.preventDefault();
      addToCart(t.getAttribute('data-cart-add'), 1)
        .then(function () { openDrawer('cart-drawer'); })
        .catch(function (err) { toast(err.message); });
      return;
    }

    if (t.hasAttribute('data-cart-change')) {
      e.preventDefault();
      changeLine(t.getAttribute('data-cart-change'), parseInt(t.getAttribute('data-qty'), 10));
      return;
    }

    if (t.hasAttribute('data-acc')) {
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!open));
      t.nextElementSibling.classList.toggle('open', !open);
      return;
    }

    if (t.hasAttribute('data-swatch')) {
      e.preventDefault();
      var card = t.closest('[data-product-card]');
      $$('[data-swatch]', card).forEach(function (b) {
        var on = b === t;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      var json = card.querySelector('[data-product-json]');
      if (json) {
        var product = JSON.parse(json.textContent);
        var value = t.getAttribute('data-swatch');
        var variant = product.variants.filter(function (v) {
          return v.options.indexOf(value) !== -1 && v.featured_image;
        })[0];
        var img = card.querySelector('.card-img');
        if (variant && img) img.src = variant.featured_image.src;
      }
      return;
    }

    if (t.hasAttribute('data-hot')) {
      var section = t.closest('[data-look]');
      var index = t.getAttribute('data-hot');
      $$('[data-hot]', section).forEach(function (b) {
        var on = b === t;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      $$('[data-look-item]', section).forEach(function (item) {
        item.hidden = item.getAttribute('data-look-item') !== index;
      });
      return;
    }

    if (t.hasAttribute('data-dlg')) {
      var dialog = document.getElementById(t.getAttribute('data-dlg'));
      if (dialog && dialog.showModal) dialog.showModal();
    }
  });

  /* ---------- Product form: variant selection, bag, gift wrap ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var section = form.closest('[data-product]');
    var product = JSON.parse(section.querySelector('[data-product-json]').textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-to-bag]');

    function currentVariant() {
      var selected = $$('input[type="radio"][data-option-position]:checked', form).map(function (r) { return r.value; });
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0] || product.variants[0];
    }

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var variant = currentVariant();
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      $$('input[type="radio"][data-option-position]', form).forEach(function (r) {
        var label = r.closest('label');
        if (label) label.classList.toggle('on', r.checked);
      });
      $$('[data-option-label]', section).forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-option-label'), 10);
        var checked = $$('input[data-option-position="' + pos + '"]:checked', form)[0];
        if (checked) el.textContent = checked.value;
      });
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = currentVariant();
      if (!variant.available) return;
      var gift = form.querySelector('input[name="properties[Gift wrapping]"]');
      var props = gift && gift.checked ? { 'Gift wrapping': 'Yes' } : null;
      addToCart(variant.id, 1, props)
        .then(function () { openDrawer('cart-drawer'); })
        .catch(function (err) { toast(err.message); });
    });

    /* Gallery zoom follows the cursor on fine pointers */
    $$('.zoomable', section).forEach(function (tile) {
      tile.addEventListener('mousemove', function (e) {
        var r = tile.getBoundingClientRect();
        var img = tile.querySelector('img');
        if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    });

    /* Delivery window: three to five business days from today */
    var delivery = section.querySelector('[data-delivery]');
    if (delivery) {
      var addBusiness = function (days) {
        var d = new Date();
        var n = 0;
        while (n < days) {
          d.setDate(d.getDate() + 1);
          var wd = d.getDay();
          if (wd !== 0 && wd !== 6) n++;
        }
        return d;
      };
      var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
      delivery.textContent = 'Order today for delivery by ' + fmt(addBusiness(3)) + ' to ' + fmt(addBusiness(5)) + '.';
    }
  });

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () { sort.form.submit(); });
  }

  /* ---------- Localization is handled in the header section ---------- */
})();
